import { FC } from 'react';

const NotFound: FC<{ message?: string }> = ({ message }) => (
  <div>
    <h1>Not Found</h1>
    <p>{message ?? "The page you tried to access doesn't exist."}</p>
  </div>
);

export default NotFound;
